<template>
	<fragment>
		<common-header
			subname="설문 관리"
			name="설문 분류"
			v-bind:menus="menus"
			v-bind:buttons="buttons"
			v-bind:mainmenuOpened="true"
		></common-header>

		<section ref="container" class="container" style="display: flex; align-items: center; justify-content: center;">
			<!-- <nav class="side-nav">
				&nbsp;
			</nav> -->

			<div class="clearfix">
				<!-- <div class="btn-group-box b-b m-b-30 clearfix">
					<div class="pull-right m-b-15 clearfix">
						<button class="btn bg-deepblue text-white round w140">안내</button>
					</div>
				</div> -->

				<div class="cat_item v-top cate2">
					<h3>대분류</h3>
					<table class="full-width table-condensed table-hover text-center">
						<vue-draggable v-model="category_list" tag="tbody" handle=".handle"
							v-bind="dragOptions" @end="moveDragEnd(category_list, $event)">
							<tr v-for="item in category_list"
								:key="item.surveyCategoryId"
								:class="{'on' : select_category == item.surveyCategoryId}"
								>

								<td @click="getList('select_category',item.surveyCategoryId, 'division_list')" class="text-left">{{item.name}}</td>
								<td class="w100">
									<a class="move m-r-5 handle">이동</a>
									<a class="modify m-r-5" :class="{ 'on' : modifyMode(item.surveyCategoryId)}" @click="setModifyList('category_input',item)">수정</a>
									<a @click="deleteItem(0, item, 'category_list')" class="del">삭제</a>
								</td>
							</tr>
						</vue-draggable>
					</table>
					<hr>
					<table class="full-width table-condensed text-center m-t-15">
						<tbody>
							<tr>
								<td >
									<input class="inline form-control-sm m-b-0 w240 v-mid round"
										type="text" placeholder="대분류명 입력" v-model="category_input">
									<button v-if="hasModify('category_list')" class="btn-sm bg-deepblue text-white round"
										type="button" @click="putItem(0, category_input, 'category_list', 'category_input')">추가</button>
									<button class="btn-sm bg-deepblue text-white round" v-else
										type="button" @click="patchList(0, 'category_list', 'category_input')">완료</button>
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div class="cat_item v-top cate2">
					<h3>중분류</h3>
					<table class="full-width table-condensed table-hover text-center">
						<vue-draggable v-model="division_list" tag="tbody" handle=".handle"
							v-bind="dragOptions"  @end="moveDragEnd(division_list, $event)">
							<tr v-for="item in division_list"
								:key="item.surveyCategoryId"
								:class="{'on' : select_division == item.surveyCategoryId}"
								>
								<td  @click="getList('select_division',item.surveyCategoryId, 'section_list')" class="text-left">{{item.name}}</td>
								<td class="w100">
									<a class="move m-r-5 handle">이동</a>
									<a class="modify m-r-5" :class="{ 'on' : modifyMode(item.surveyCategoryId)}" @click="setModifyList('division_input',item)">수정</a>
									<a class="del" @click="deleteItem(select_category, item, 'division_list')">삭제</a>
								</td>
							</tr>
						</vue-draggable>
					</table>
					<hr>
					<table class="full-width table-condensed text-center m-t-15">
						<tbody>
							<tr>
								<td>
									<input class="inline form-control-sm m-b-0 w240 v-mid round"
										type="text" placeholder="중분류명 입력" v-model="division_input">
									<button class="btn-sm bg-deepblue text-white round" v-if="hasModify('division_list')"
										type="button" @click="putItem(select_category, division_input, 'division_list', 'division_input')">추가</button>
									<button class="btn-sm bg-deepblue text-white round" v-else
										type="button" @click="patchList(select_category, 'division_list', 'division_input')">완료</button>
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div class="cat_item v-top">
					<h3>소분류</h3>
					<table class="full-width table-condensed table-hover text-center">
						<vue-draggable v-model="section_list" tag="tbody" handle=".handle"
							v-bind="dragOptions"  @end="moveDragEnd(section_list, $event)">
							<tr v-for="item in section_list"
								:key="item.surveyCategoryId">
								<td class="text-left">{{item.name}}</td>
								<td class="w100">
									<a class="move m-r-5 handle">이동</a>
									<a class="modify m-r-5" :class="{ 'on' : modifyMode(item.surveyCategoryId)}" @click="setModifyList('section_input', item)">수정</a>
									<a class="del" @click="deleteItem(select_division, item, 'section_list')">삭제</a>
								</td>
							</tr>
						</vue-draggable>
					</table>
					<hr>
					<table class="full-width table-condensed text-center m-t-15">
						<tbody>
							<tr>
								<td>
									<input class="inline form-control-sm m-b-0 w240 v-mid round" type="text" placeholder="소분류명 입력" v-model="section_input">
									<button class="btn-sm bg-deepblue text-white round" v-if="hasModify('section_list')"
										type="button" @click="putItem(select_division, section_input, 'section_list', 'section_input')">추가</button>
									<button class="btn-sm bg-deepblue text-white round" v-else
										type="button" @click="patchList(select_division, 'section_list', 'section_input')">완료</button>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</section>

		<common-footer></common-footer>
	</fragment>
</template>

<script>
import fnAdjustHeight from '../mixins/fnAdjustHeight.js'
import VueDraggable from 'vuedraggable'
import CommonHeader from '../components/CommonHeader.vue'
import CommonFooter from '../components/CommonFooter.vue'
import server from '../statics/server'
import _ from 'lodash'
export default {
	name: "ViewSurveyCategoryManager",
	mixins: [fnAdjustHeight],

	// 컴포넌트가 그려지기 직전에 호출되는 함수
	mounted: function() {
		//this.getCatetegoryData(0, 0)();
		/*
			대분류 : category
			중분류  : division
			소분류 :  section
		*/
		//this.getCategoryList();
		this.getList('select_category', 0, 'category_list')
	},

	components: {
		VueDraggable,
		CommonHeader,
		CommonFooter,
	},
	data: function() {
		return {
			menus: [ // 서브메뉴
				{name:'설문 관리',link:"/surveys",selected:false},
				{name:'설문문항 관리',link:"/surveyItems",selected:false},
				{name:'설문 분류',link:"/surveys/categories",selected:true},
				{name:'설문 통계',link:"/surveys/statistics",selected:false},
			],
			buttons: [], // 헤더버튼
			categoriesInput: ["", "", ""], // 카테고리 입력 값 : 0 대분류 1 중분류 2 소분류
			temp_data : [
				{
					surveyCategoryId : 1,
					parentsId : 0,
					name : '1단계 카테고리 1',
				},
				{
					surveyCategoryId : 2,
					parentsId : 0,
					name : '1단계 카테고리 2',
				},
				{
					surveyCategoryId : 3,
					parentsId : 0,
					name : '1단계 카테고리 3',
				},

				{
					surveyCategoryId : 4,
					parentsId : 1,
					name : '2단계 카테고리 1-1',
				},
				{
					surveyCategoryId : 5,
					parentsId : 1,
					name : '2단계 카테고리 1-2',
				},
				{
					surveyCategoryId : 6,
					parentsId : 2,
					name : '2단계 카테고리 2-1',
				},

				{
					surveyCategoryId : 7,
					parentsId : 4,
					name : '1단계 카테고리 1-1-1',
				}

			],
			category_input : '',
			division_input : '',
			section_input : '',
			modify_list : [], // 수정 리스트
			category_list : [], // 대분류
			division_list : [], // 중분류
			section_list : [], // 소분류
			select_category : -1, // 대분류 선택
			select_division : -1, // 중분류 선택
		}
	},

	methods: {
		modifyMode(surveyCategoryId){
			// 수정 모드 = true
			return _.findIndex(this.modify_list, {surveyCategoryId}) != -1;
		},
		hasModify(level){
			const self = this;
			let result = true;
			_.forEach(this[level], (category, idx) => {
				idx;
				if(_.findIndex(self.modify_list, category) != -1) {
					result = false;
				}
			})
			return result;
		},
		getList (select_name, parentsId_val, list_name){
			// select_name : 선택 분류, parentsId_val : 검색할 카테고리 아이디 list_name : 갱신 할 리스트 명
			const self = this;
			let parentsId = parentsId_val || 0;
			if(select_name != ''){
				self[select_name] = parentsId;
			}
			server.postAxios('SURVEY_CATEGORY',  { parentsId }, ({data , err}) => {
				err;
				self[list_name] = _.filter(data.list, {parentsId})
			});
		},
		putItem(parentsId, name, list_name, input_name){
			// parentsId : 부모 ID, name : 분류명, list_name : 갱신할 리스트명
			const self = this;
			server.putAxios('SURVEY_CATEGORY',  { parentsId, name }, ({data , err}) => {
				data;
				err;
				// eslint-disable-next-line
				console.log('name : ', name)
				self[input_name] = '';
				self.getList('', parentsId, list_name)
			});
		},
		patchList(parentsId, list_name, input_name){
			// parentsId : 부모 ID, name : 분류명, list_name : 갱신할 리스트명
			const self = this;
			let patch_data = _.filter(self.modify_list, {parentsId})[0];
			let patch_config = { name : self[input_name] }
			server.patchAxios('SURVEY_CATEGORY',  patch_data.surveyCategoryId, patch_config, ({data , err}) => {
				data;
				err;
				self.getList('', parentsId, list_name);
				self[input_name] = '';
				_.forEach(self.modify_list, (category, idx) => {
					idx;
					if(_.findIndex(self[list_name], {surveyCategoryId : category.surveyCategoryId}) != -1){
						self.modify_list = _.reject(self.modify_list, category);
					}
				})
			});
		},
		deleteItem(parentsId, item, list_name){
			const self = this;
			// surveyCategoryId
			server.deleteAxios('SURVEY_CATEGORY',  { id : item.surveyCategoryId }, ({data , err}) => {
				data;
				err;
				self.getList('', parentsId, list_name);
			});
		},
		setModifyList (input_name, item){
			const self = this;
			this[input_name] = item.name;
			self.modify_list = _.reject(self.modify_list,  {parentsId : item.parentsId});
			self.modify_list.push(item);
		},
		moveDragEnd(list, $event){
			$event;
			_.forEach(list, (obj ,idx) => {
				let patch_config = {
					ord : idx
				}
				server.patchAxios('SURVEY_CATEGORY',  obj.surveyCategoryId, patch_config, ({data , err}) => {
					data;
					err;
				});
			})
		},
	},

	// 미리 계산된 option 값 들
	computed: {
		dragOptions() {
			return {
				ghostClass: "ghost"
			}
		}
	}
}
</script>

<style>
.cat_item tr:hover {
	background: none;
	box-shadow: none;
}
.ghost {
	box-shadow: 0px 2px 5px 2px rgba(0, 0, 0, 0.2) !important;
	background-color: #e1e3eb !important;
}
</style>



















